import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { useAuth } from './store/auth';
import Layout from './components/Layout';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Attendance from './pages/Attendance';
import LeaveList from './pages/LeaveList';
import ClaimsList from './pages/ClaimsList';
import LeaveBalance from './pages/LeaveBalance';
import Employees from './pages/Employees';
import LeaveNew from './pages/LeaveNew';
import ClaimNew from './pages/ClaimNew';
import Announcements from './pages/Announcements';
import Notifications from './pages/Notifications';
import Profile from './pages/Profile';
import LoadingState from './components/ui/LoadingState';
import InstallPrompt from './components/InstallPrompt';
import Onboarding from './pages/Onboarding';

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading, checked, onboarding } = useAuth();
  const location = useLocation();
  if (!checked || loading) {
    return (
      <div className="flex h-dvh flex-col items-center justify-center bg-background px-6">
        <LoadingState label="Loading…" rows={2} />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (onboarding?.pdpaRequired && location.pathname !== '/onboarding') {
    return <Navigate to="/onboarding" replace />;
  }
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route
        path="/onboarding"
        element={
          <Protected>
            <Onboarding />
          </Protected>
        }
      />
      <Route
        path="/"
        element={
          <Protected>
            <Layout />
            {/* Mounted here, not in main.tsx: it must never appear on /login. */}
            <InstallPrompt />
          </Protected>
        }
      >
        <Route index element={<Navigate to="/dashboard" replace />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="attendance" element={<Attendance />} />
        <Route path="leave" element={<LeaveList />} />
        <Route path="leave/new" element={<LeaveNew />} />
        <Route path="claims" element={<ClaimsList />} />
        <Route path="claims/new" element={<ClaimNew />} />
        <Route path="leave-balance" element={<LeaveBalance />} />
        <Route path="employees" element={<Employees />} />
        <Route path="announcements" element={<Announcements />} />
        <Route path="notifications" element={<Notifications />} />
        <Route path="profile" element={<Profile />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
